export default __webpack_public_path__ + "static/media/cellnet_logo_white_old.becee5a1.svg";